import styled from '@emotion/styled'
import { transparentize } from 'polished'

import { Color } from '../../../../enums/color'
import { paginationDotAnimation } from '../../utils/paginationDotAnimation'

interface PaginationTrackProps {
  translateValue: number
}

export const PaginationTrack = styled.div<PaginationTrackProps>`
  display: flex;
  transform: ${({ translateValue }) => `translateX(-${translateValue}px);`};
  transition: transform 0.3s ease-in-out;
`

export const PaginationWrapper = styled.div`
  display: flex;
  max-width: 75px;
  border-radius: 30px;
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  background-color: ${Color.White};
  box-shadow: 0 2px 4px 0 ${transparentize(0.8, Color.Grey300)};
  overflow: hidden;
`

interface PaginationItemProps {
  active: boolean
}

export const PaginationItem = styled.div<PaginationItemProps>`
  width: ${({ active }) => (active ? '18px' : '6px')};
  height: 6px;
  margin: 2px 3px;
  border: none;
  border-radius: 30px;
  transform-origin: center;
  background-color: ${({ active }) => (active ? Color.Black : Color.Grey150)};
  cursor: pointer;
  transition:
    transform 0.3s ease-in-out,
    width 0.3s ease-in-out,
    background-color 0.5s ease-in-out;
  ${({ active }) => paginationDotAnimation(active)}
`
